import { render, staticRenderFns } from "./InvestmentManagerIndexPage.vue?vue&type=template&id=1de36e39&"
import script from "./InvestmentManagerIndexPage.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports